import { CTA } from "@/data/content";
import { scrollToId } from "@/lib/scroll";

const VARIANTS = {
  primary:
    "bg-brand text-white shadow-glow-soft hover:bg-brand-light hover:shadow-glow-soft",
  chrome:
    "bg-gradient-to-b from-silver-bright to-silver text-ink-950 shadow-[0_12px_34px_-14px_rgba(200,209,220,0.45)] hover:from-white hover:to-silver-bright",
  ghost:
    "border border-line text-fg-muted hover:border-silver-mid hover:text-fg",
};

const Arrow = () => (
  <svg
    width="14"
    height="14"
    viewBox="0 0 24 24"
    fill="none"
    stroke="currentColor"
    strokeWidth="2.5"
    strokeLinecap="round"
    strokeLinejoin="round"
    aria-hidden="true"
  >
    <path d="M5 12h14M13 6l6 6-6 6" />
  </svg>
);

// Funnel/homepage CTA. With `href` it renders an anchor (exact destination
// preserved); otherwise it smooth-scrolls to `targetId`.
export default function CTAButton({
  label = CTA.label,
  href,
  targetId = CTA.targetId,
  variant = "primary",
  testId,
  className = "",
}) {
  const cls = `inline-flex items-center justify-center gap-2.5 rounded-full px-8 py-4 text-sm font-bold uppercase tracking-[0.16em] transition-all duration-300 ease-out hover:-translate-y-0.5 active:translate-y-0 ${VARIANTS[variant]} ${className}`;
  if (href) {
    return (
      <a href={href} data-testid={testId} className={cls}>
        {label}
        <Arrow />
      </a>
    );
  }
  return (
    <button
      type="button"
      data-testid={testId}
      onClick={() => scrollToId(targetId)}
      className={cls}
    >
      {label}
      <Arrow />
    </button>
  );
}